import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './packages.css';
import BaliImage from "../../assets/bali.jpg";
import JapanImage from "../../assets/japan.jpg";
import ItalyImage from "../../assets/italy.jpg";
import ScotlandImage from "../../assets/scotland.jpg";
import IrelandImage from "../../assets/ireland.jpg";
import NorwayImage from "../../assets/norway.jpg";

function Packages() {
    const [flippedIndex, setFlippedIndex] = useState(null);
    const destinations = [
        {
            name: "Bali",
            image: BaliImage,
            days: 7,
            price: "$1200",
            description: "Experience Bali's serene beaches, vibrant culture, and stunning landscapes. Visit iconic temples, relax on Nusa Dua's beaches, and explore Ubud's arts and crafts. Enjoy local cuisine and immerse yourself in the island's unique blend of adventure and relaxation."
        },
        {
            name: "Japan",
            image: JapanImage,
            days: 10,
            price: "$2000",
            description: "Discover Japan's blend of tradition and modernity. Explore Tokyo's vibrant cityscape, Kyoto's historic temples, and the scenic beauty of Mount Fuji. Savor Japan's culinary delights, from sushi to ramen, in a country where history meets innovation."
        },
        {
            name: "Italy",
            image: ItalyImage,
            days: 12,
            price: "$2500",
            description: "Explore Italy's rich history, art, and cuisine. Wander through Rome's ancient ruins, Venice's romantic canals, and Florence's Renaissance masterpieces. Taste diverse Italian dishes and experience the country's vibrant culture and scenic beauty."
        },
        {
            name: "Scotland",
            image: ScotlandImage,
            days: 8,
            price: "$1800",
            description: "Journey through Scotland's rugged highlands and historic castles. Discover Edinburgh's medieval charm, the Highlands' dramatic landscapes, and the mystical Loch Ness. Enjoy Scotland's whisky heritage and explore the stunning Isle of Skye."
        },
        {
            name: "Ireland",
            image: IrelandImage,
            days: 9,
            price: "$1900",
            description: "Experience Ireland's lush landscapes and lively culture. Explore Dublin's literary heritage, the Cliffs of Moher, and the mystical Ring of Kerry. Discover ancient ruins and enjoy traditional Irish music in cozy pubs across the country."
        },
        {
            name: "Norway",
            image: NorwayImage,
            days: 10,
            price: "$2200",
            description: "Explore Norway's majestic fjords and northern lights. Visit Oslo, cruise through stunning fjords, and experience the natural beauty of the Lofoten Islands. In winter, witness the magical northern lights in Tromsø, the gateway to the Arctic."
        }
    ];    

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    return (
        <div className="packages">
            <div className="component-name">Tour suggestions</div>
            <div className="component-head">
                <h2>Our favourite suggestions</h2>
                <p>Our handpicked travel destinations with itineraries that is adventurous and fit your pockets like a 😘.</p>
            </div>
            <Slider {...sliderSettings}>
                {destinations.map((dest, index) => (
                    <div key={index}>
                        <div
                            className={`card ${flippedIndex === index ? 'flipped' : ''}`}
                            onClick={() => setFlippedIndex(flippedIndex === index ? null : index)}
                        >
                            <div className="card-inner">
                                <div
                                    className="card-front"
                                    style={{ backgroundImage: `url(${dest.image})` }}
                                >
                                    <div className="card-info">
                                        <span id="price">{dest.price}</span>
                                        <div className="card-image">
                                            <span>{dest.name}</span>
                                            <span>{dest.days} days</span>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="card-back"
                                    style={{ backgroundImage: `url(${dest.image})` }}
                                >
                                    <div className="card-content">
                                        <p>{dest.description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default Packages;
